import { generateQueryStringFromParams } from '@/utils/history';
import { ApiTagTypes, innovorderApi } from '../index';
import { ApiResponse } from '../request.types';
import { GetLibraryFilesPayload, GetLibraryFilesResponse, UploadFilePayload, UploadFileResponse } from './library.type';

const libraryApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getFiles: build.query<GetLibraryFilesResponse, GetLibraryFilesPayload>({
            query: ({ brandId, restaurantId, limit, offset, search }) => {
                const queryParameters = generateQueryStringFromParams({ limit, offset, search });
                const endpoint = restaurantId ? `/restaurant/${restaurantId}` : `/brand/${brandId}`;
                return {
                    url: `/library${endpoint}?${queryParameters}`,
                    method: 'GET',
                };
            },
            providesTags: (response, _, queryArgs) => {
                if (response) {
                    return [
                        ...response.map(({ imageId }) => ({
                            type: ApiTagTypes.Library,
                            id: `${queryArgs.brandId}-${imageId}`,
                        })),
                        { type: ApiTagTypes.Library, id: `${queryArgs.brandId}-LIST` },
                    ];
                }
                return [{ type: ApiTagTypes.Library, id: 'LIST' }];
            },
            transformResponse: (response: ApiResponse<GetLibraryFilesResponse>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        uploadFile: build.mutation<UploadFileResponse, UploadFilePayload>({
            query: ({ resize = true, brandId, restaurantId, file }) => {
                const queryParameters = generateQueryStringFromParams({ resize: resize ? 'true' : undefined });
                const formData = new FormData();
                formData.append('file', file);

                const endpoint = restaurantId ? `/restaurant/${restaurantId}` : `/brand/${brandId}`;
                return {
                    url: `/library${endpoint}?${queryParameters}`,
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: (_, __, queryArgs) => {
                return [{ type: ApiTagTypes.Library, id: `${queryArgs.brandId}-LIST` }];
            },
            transformResponse: (response: ApiResponse<UploadFileResponse>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
    }),
});

export const { useUploadFileMutation, useGetFilesQuery } = libraryApi;
